class TransformInspection{
    static getArrayPictures(files) {
        let enabledTires = true;
        let images = [];
        files.forEach((file) =>  {
            switch(true){
                case file.pictureCode === 'TIRE':
                    if(file.files.length){
                        enabledTires = false;
                        images.push(file);
                    }
                    break;
                case file.pictureCode === 'TIRE_FRONT_RIGHT':
                case file.pictureCode === 'TIRE_FRONT_LEFT':
                case file.pictureCode === 'TIRE_BACK_RIGHT':
                case file.pictureCode === 'TIRE_BACK_LEFT':
                    if(enabledTires){
                        images.push(file);
                    }
                    break;
                case file.pictureCode === 'SPARE_TIRE':
                    images.push(file);
                    break;
                default: 
                    images.push(file);
            }

        });
        return images;
    }

    static getArrayAccessories(files){
        let images = [];
        files.forEach((file) =>  {
            switch(true){
                case file.accessoryCode === 'WHEEL':
                case file.accessoryCode === 'RIM':
                    break;
                default: 
                    images.push(file);
            }

        });
        return images;   
    }

    static getPicturesWithObservations(pictures, damages, accessories) {
        let picturesObserved = [];
        const  allPictures = pictures.concat(damages, accessories);
        allPictures.length > 0 && allPictures.find((pic) => {
            if (pic.observationCode && pic.observationCode.length > 0) {
                if (pic.pictureCode) {
                    pic.type = 'PICTURE';
                } else if (pic.damageCode) {
                    pic.type = 'DAMAGE';
                } else {
                    pic.type = 'ACCESSORY'
                }
            picturesObserved.push(pic);
            }
        })
        return picturesObserved;
    }
    static getReasonObservation(observationCode, observations) {
        let reasons = [];
        let reason;
        const arrayCodes = observationCode.split(",");
        if (arrayCodes.length > 1) {
            arrayCodes.forEach((code) => {
                reason = observations.find(ob => ob.id === code);
                reasons.push(reason);
            })
        } else {
            reason = observations.find(ob => ob.id === arrayCodes[0]);
            reasons.push(reason);
        }
        return reasons;
    }
}
export default TransformInspection;



// WEBPACK FOOTER //
// ./src/lib/utils/transforms/inspection.js